// extracted by mini-css-extract-plugin
module.exports = {"image":"jgp-HEhDm","imageWrapper":"jgp-3CYgl","stream":"jgp-iUb77","overlayButton":"jgp-nxIim","videoPopout":"jgp-2I5EA"};